import React, { useCallback, useEffect, useState } from 'react'

import { ConfigureLocalRunProps } from './ConfigureLocalRun.types'

import { CloudPlus, Cpu, Laptop, X } from 'react-bootstrap-icons'
import { Label, NumberInput } from '../atoms'

import ButtonGroup from '../atoms/ButtonGroup/ButtonGroup'
import SelectLocalArtifactNative from '../SelectLocalArtifactNative/SelectLocalArtifactNative'

export const _defaultConfig = {
  localCPUCount: 1,
  localRunFolder: null,
  isLocalJob: false,
  cloudProjectName: undefined,
  cloudProjectOwner: undefined,
  useHandlers: false
}

export const ConfigureLocalRun: React.FC<ConfigureLocalRunProps> = ({ 
  defaultVal,
  onChange,
  disabled = false,
  showCpu = false
}) => {

  const [localConfig, setLocalConfig] = useState({ ..._defaultConfig, ...defaultVal })

  useEffect(() => {
    if (!localConfig || !onChange) return
    onChange(localConfig)
  }, [localConfig, onChange])

  const handleLocalPathChange = useCallback(( localRunFolder ) => {
    setLocalConfig(config => ({ ...config, localRunFolder }))
  },[])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        fontSize: '12px'
      }}
    >
      <Label
        label="Configure Run"
      >
        <ButtonGroup
          wrapperProps={{
            style:{
              width:'fit-content'
            }
          }}
        >
          <button
            type='button'
            disabled={disabled}
            onClick={() => setLocalConfig(state => ({ ...state, isLocalJob: false }))}
            style={{
              display: 'flex',
              boxShadow: !disabled && !localConfig.isLocalJob ? 
                'inset 0px 0px 9px 4px #096dd9' : undefined
            }}
          >
            <CloudPlus/>
          Cloud
          </button>
          <button
            type='button'
            disabled={disabled}
            onClick={() => setLocalConfig(state => ({ ...state, isLocalJob: true }))}
            style={{
              display: 'flex',
              boxShadow: !disabled && localConfig.isLocalJob ? 
                'inset 0px 0px 9px 4px #096dd9' : undefined
            }}
          >
            <Laptop/>
          Local
          </button>
        </ButtonGroup>
      </Label>
      {localConfig.isLocalJob && showCpu && <Label
        label="Number of CPUs"
        disabled={!localConfig.isLocalJob}
        style={{
          backgroundColor:'white'
        }}
      >
        <NumberInput
          icon={<Cpu />} 
          inputProps={{
            min: 1,
            step: 1,
            max: 100,
            disabled: !localConfig.isLocalJob,
            defaultValue: localConfig && localConfig.localCPUCount,
            onChange: (event) => {
              event.persist()
              // @ts-ignore
              setLocalConfig(config => ({ ...config, localCPUCount: event.target.value }))
            }
          }}
        />
      </Label>}
      {localConfig.isLocalJob && <Label
        label="Select a Local Run Folder"
        disabled={!localConfig.isLocalJob}
      >
        <SelectLocalArtifactNative 
          disabled={!localConfig.isLocalJob}
          onChange={handleLocalPathChange}
          mode='directory'
          buttonLabel='Local Run Folder'
          value={localConfig && localConfig.localRunFolder}
        />
      </Label>}
    </div>
  )
}

export default ConfigureLocalRun